import { render } from "./isfc.vue?vue&type=template&id=40e37d32&scoped=true"
import script from "./isfc.vue?vue&type=script&lang=js"
export * from "./isfc.vue?vue&type=script&lang=js"

import "./isfc.vue?vue&type=style&index=0&id=40e37d32&lang=less&scoped=true"

import exportComponent from "/Users/imp/work/credit_chkra_ios/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40e37d32"]])

export default __exports__